import { createContext, useEffect, useState } from "react";

export const SubscriptionContext = createContext();

const SubscriptionContextProvider = (props) => {
  const [subscription, setSubscription] = useState();

  const [subscriptionFeatures, setSubscriptionFeatures] = useState({});

  useEffect(() => {
    if (!subscription) return;
    const subscriptions = {};
    subscription?.subscriptionFeatures.forEach((x) => {
      subscriptions[x.featureCode] = x;
    });
    setSubscriptionFeatures(subscriptions);

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (...args) {
      this._tenantHeaderInjected = false;
      return originalOpen.apply(this, args);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      if (!this._tenantHeaderInjected) {
        this.setRequestHeader("X-Tenant-Id", subscription.id);
        this._tenantHeaderInjected = true;
      }

      return originalSend.apply(this, args);
    };
  }, [subscription]);

  return (
    <SubscriptionContext.Provider
      value={{ subscription, setSubscription, subscriptionFeatures }}
    >
      {props.children}
    </SubscriptionContext.Provider>
  );
};

export default SubscriptionContextProvider;
